import PropTypes from 'prop-types';
import React from 'react';
import ArticleList from '../components/ArticleCardList';
import HomeBox from '../components/Box/Home';
import ProductBox from '../components/Box/Product';
import CostComparation from '../components/CostComparation';
import Footer from '../components/Footer';
import Header from '../components/Header';
import SectionHeader from '../components/Header/Section';
import Video from '../components/Header/Video';
import Newsletter from '../components/Newsletter';
import Social from '../components/Social';
import TestCTA from '../components/TestCTA';
import causa from '../content/home/causa.json';
import endomarketing from '../content/home/endomarketing.json';
import grandeEmpresa from '../content/home/grande-empresa.json';
// content
import pequenoNegocio from '../content/home/pequeno-negocio.json';
import personalidade from '../content/home/personalidade.json';
import politica from '../content/home/politica.json';
import logo2 from '../sass/images/logo-mem.png';
import logo3 from '../sass/images/logo-social-bakers.png';
// Images
import logo1 from '../sass/images/logo-techtudo.png';






const homeContent =  {
  'pequeno-negocio': pequenoNegocio,
  'causa': causa,
  'endomarketing': endomarketing,
  'grande-empresa': grandeEmpresa,
  'personalidade': personalidade,
  'politica': politica
}

class IndexPage extends React.Component {

  static contextTypes = {
    t: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)

    this.state = {
      content: {},
      articles: [
        {
          image: 'http://placehold.it/348x195',
          title: 'Iniciando no Talkative: estratégias em um novo paradigma globalizado',
          date: '22/12/2017',
          url: 'http://www.example.com',
          category: {
            name: 'Talkative',
            url: 'http://www.example.com'
          }
        },
        {
          image: 'http://placehold.it/348x195',
          title: 'Iniciando no Talkative: estratégias em um novo paradigma globalizado',
          date: '22/12/2017',
          url: 'http://www.example.com',
          category: {
            name: 'Talkative',
            url: 'http://www.example.com'
          }
        },
        {
          image: 'http://placehold.it/348x195',
          title: 'Iniciando no Talkative: estratégias em um novo paradigma globalizado',
          date: '22/12/2017',
          url: 'http://www.example.com',
          category: {
            name: 'Talkative',
            url: 'http://www.example.com'
          }
        }
      ],
      media: [
        {
          image: logo1,
          title: '"Talkative: estratégias em um novo paradigma globalizado."',
          url: 'http://example.com'
        },
        {
          image: logo2,
          title: '"Nova ferramenta facilita a criação do sistema de participação geral."',
          url: 'http://example.com'
        },
        {
          image: logo3,
          title: '"Talkative is a game changer fro brands in the digital world."',
          url: 'http://example.com'
        }
      ]
    }
  }

  componentDidMount() {
    document.body.classList.add('home', 'white-bg')
    const path = this.props.location.pathname.substr(1)
    fetch('https://api.talkative.media/v1/blog')
        .then(response => response.json())
        .then(response => {
            this.setState({
                articles: response.results,
                content: homeContent[path]
            })
        })
  }

  componentDidUpdate(prevProps, prevState) {
    if(prevProps.location.pathname === this.props.location.pathname) return;

    const path = this.props.location.pathname.substr(1)
    this.setState({
      content: homeContent[path]
    })
  }

  componentWillUnmount() {
    document.body.classList.remove('home', 'white-bg')
  }

  render() {
    const { content } = this.state;
    return (
      <div>
        <Header name="new-home-header">
          <div className="container">
            <div className="grid">
              <div className="col-6_xs-12">
                <h2>
                  {this.context.t(content.header ? content.header.title : '', {}, 'Texto do cabeçalho')}
                </h2>
                <p>{this.context.t(content.header ? content.header.subtitle : '', {}, 'Texto do cabeçalho')}</p>
                <div className="cta-container">
                  <TestCTA />
                </div>
              </div>
              <div className="col-6_xs-12">
                <Video videoId="OyM9E7CesP4" position="bottom left" text="Conheça o Talkative" background={require('../sass/images/video-bg2.png')} />
              </div>
            </div>
          </div>
        </Header>
        <section>
          <HomeBox content={content.homeBox} title={content.homeBoxTitle} />
        </section>

        <section style={{backgroundColor: '#f4f7f8'}}>
          <ProductBox content={content.productBox} />
          <Social />
        </section>

        <section>
          <SectionHeader>
            <div className="container">
              <div className="grid-center">
                <div className="col-6_xs-12">
                  <h2>Invista menos dinheiro para maior resultado.</h2>
                  <p>Com o Talkative você economiza em mídia e ganha em boca-a-boca, a propaganda mais poderosa que existe.</p>
                </div>
              </div>
            </div>
          </SectionHeader>
          <CostComparation />
        </section>

        {/* <section style={{backgroundColor: '#f4f7f8'}}>
          <SectionHeader>
            <div className="container">
              <div className="grid-center">
                <div className="col-6_xs-12">
                  <h2>Casos de sucesso</h2>
                  <p>Conheça alguns pequenos negócios que usaram o Talkative para mudar completamente sua presença digital.</p>
                </div>
              </div>
            </div>
          </SectionHeader>
          <Cases />
          <ClientSlide />
        </section> */}

        <section>
          <SectionHeader>
            <div className="container">
              <div className="grid-center">
                <div className="col-8_xs-12">
                  <h2>Artigos</h2>
                  <p>Nossa equipe está sempre escrevendo ou escolhendo os melhores artigos para que você entenda as mudanças, as novidades, as plataformas e como obter os melhores resultados com a comunicação digital.</p>
                </div>
              </div>
            </div>
          </SectionHeader>
          <ArticleList cards={this.state.articles} />
        </section>

        <section style={{backgroundColor: '#f4f7f8'}}>
          <Newsletter />
        </section>

        {/* <section>
          <SectionHeader>
            <div className="container">
              <div className="grid-center">
                <div className="col-8_xs-12">
                  <h2>Talkative na mídia</h2>
                  <p>Veja o que estão falando de nós</p>
                </div>
              </div>
            </div>
          </SectionHeader>
          <MediaList cards={this.state.media} />
        </section> */}

        {/* <section style={{backgroundColor: '#f4f7f8'}}>
          <SectionHeader>
            <div className="container">
              <div className="grid-center">
                <div className="col-6_xs-12">
                  <h2>Palavra dos clientes</h2>
                  <p>Saiba o que os nossos clientes estão achando do Talkative</p>
                </div>
              </div>
            </div>
            <Testimonials />
          </SectionHeader>
        </section> */}

        <Footer />
      </div>
    )
  }
}

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js